import { useState, useEffect } from 'react';
import { ActivityOverviewSupportDto } from '../../../../core/api/FitnessActivityClient';
import { MapWorkout } from './GpxMap.types';
import {
    fetchAndParseGpx as fetchGpxFromUrl,
    parseGpxCoordinates,
    getColorForId
} from './GpxMap.utils';

interface UseGpxMapStoreProps {
    data: ActivityOverviewSupportDto | null;
}

export const useGpxMapStore = ({ data }: UseGpxMapStoreProps) => {
    const [parsedWorkouts, setParsedWorkouts] = useState<MapWorkout[]>([]);

    useEffect(() => {
        if (!data?.workouts) {
            setParsedWorkouts([]);
            return;
        }

        let isMounted = true;

        const loadWorkouts = async () => {
            const workoutsWithGpx = await Promise.all(
                data.workouts.map(async (workout) => {
                    let positions: Array<[number, number]> = [];

                    if (workout.gpxFileUrl) {
                        try {
                            const gpxContent = await fetchGpxFromUrl(
                                workout.gpxFileUrl
                            );
                            positions = parseGpxCoordinates(gpxContent);
                        } catch (error) {
                            console.error(
                                `Error processing GPX for workout at ${workout.gpxFileUrl}:`,
                                error
                            );
                        }
                    }
                    return {
                        id: `${workout.id}`,
                        type: workout.workoutType,
                        positions,
                        color: getColorForId(`${workout.id}`)
                    };
                })
            );

            if (isMounted) {
                setParsedWorkouts(
                    workoutsWithGpx.filter((w) => w.positions.length > 0)
                );
            }
        };

        loadWorkouts();

        return () => {
            isMounted = false;
        };
    }, [data?.workouts]);

    return {
        parsedWorkouts
    };
};
